<template>
    <div class="logoSection">
        <div class="float-right ml-3">
            <div class="online-pulsating-circle"></div>
            <span class="d-block mr-5 text"> لایوی </span>
            <span class="d-block mr-5 logoTxt text"> نمایش زنده جهان </span>
        </div>
        <div class="float-left logoSecLeftTxt pl-2">
            <a :href="item.link"
               class="ml-2"
               :class="{ active: isActive(item.link) }"
               v-for="item in items"
               :key="item.link">
                <small> {{ item.text }} </small>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Logo",
        props: ["items"],
        methods: {
            isActive(link) {
                const path = this.$route.path;
                // "/" should only match the home page itself, not every route.
                if (link === '/') return path === '/';
                // Match exact or nested routes (e.g. /map matches /map/category/2).
                return path === link || path.startsWith(link + '/');
            }
        }
    }
</script>

<style>

</style>

<style lang="scss" scoped>
    @import "@/assets/css/tokens";

    .logoSection {
        position: fixed;
        top: 10px;
        right: 10px;
        height: 60px;
        min-width: 170px;
        direction: ltr !important;
        border-radius: 12px;
        padding: 7px 7px 0;
        z-index: 2 !important;
        background: $bg-card;
        box-shadow: 0 1px 3px rgba($accent-blue, 0.10), 0 1px 2px rgba($accent-blue, 0.18);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
        overflow: hidden;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 4px;
            background: $gradient-main;
            border-radius: 0 12px 12px 0;
        }

        &:hover {
            box-shadow: 0 6px 16px rgba($accent-blue, 0.12), 0 2px 4px rgba($accent-blue, 0.18);
        }
    }

    .logoTxt {
        font-size: 12px;
    }

    .logoSecLeftTxt {
        padding-top: 12px;
        a {
            color: $text-secondary;
            transition: color 0.2s ease, font-weight 0.2s ease;
            &:hover {
                color: $accent-blue;
            }
            &.active {
                color: $accent-blue;
                font-weight: 700;
            }
        }
    }

    .text {
        background: $gradient-main;
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
    }
</style>
